export default __webpack_public_path__ + "static/media/LandingPageVideoPortrait.053efd56.mp4";